import { SettingKey } from 'data/ppoints/constants';
import { ShippingType } from 'features/orders/models/ShippingType';
import { ShopifyOrder } from 'features/orders/models/ShopifyOrder';
import OrderService from 'features/orders/services/OrderService';
import SettingService from 'features/settings/services/SettingService';
import httpApi from 'hooks/api/httpApi';
import { GlsCreateParcelsResponse } from 'models/ppoints/GlsCreateParcelsResponse';
import { GlsOrderStatus } from 'models/ppoints/GlsOrderStatus';
import { GlsShippingInformation } from 'models/ppoints/GlsShippingInformation';
import { GlsApiKeysSetting } from 'models/ppoints/settings/SettingsToEcom';
import ApiKeyService from 'services/settings/ppoints/ApiKeyService';
import { downloadFileContent } from 'utils/utils';

let store;
const injectStore = (_store) => {
    store = _store;
};

const isApiKeyValid = async (ecomId: number, testMode: boolean): Promise<boolean> => {
    const apiTestMode: boolean = store.getState().settings.settings[SettingKey.use_test_api_gls];
    let apiKeys: GlsApiKeysSetting | null = null;
    if (apiTestMode) {
        apiKeys = store.getState().settings.settings[SettingKey.test_api_keys_gls];
    } else {
        apiKeys = store.getState().settings.settings[SettingKey.gls_api_keys];
    }
    return (
        (await ApiKeyService.validateGls(ecomId, testMode, apiKeys?.username || '', apiKeys?.password || '')) === true
    );
};
const checkApiKeysWithErrorToast = async (ecomId: number, testMode: boolean) => {
    if (!(await isApiKeyValid(ecomId, testMode))) {
        // TODO: add banner!!!!
        // toastUtils.error('Gls Api Keys are invalid!');
        throw new Error('Gls Api Keys are invalid!');
    }
};

const getShippingInfoForOrders = async (ecomId: number, orderIds: number[]) => {
    let res = await httpApi.post<GlsShippingInformation[]>(`/api/ecom/${ecomId}/gls/shipping-info`, {
        shopify_order_ids: orderIds,
    });
    let data = res.getData();
    return data;
};

const getShippingInfoForOrder = async (ecomId: number, orderId: number) => {
    let res = await httpApi.post<GlsShippingInformation>(`/api/ecom/${ecomId}/gls/shipping-info`, {
        shopify_order_ids: [orderId],
    });
    let data = res.getData();
    return data[0] || null;
};

const downloadLabelsPdfForOrderIds = async (ecomId: number, orderIds: number[]) => {
    let res = await httpApi.post<string>(`/api/ecom/${ecomId}/gls/download-labels-zip`, {
        shopify_order_ids: orderIds,
    });
    let data = res.getData();
    downloadFileContent(data, `gls-labels-${self.crypto.randomUUID()}.zip`);
};

const getStatus = (
    ecomId: number,
    order: ShopifyOrder,
    glsShippingInfo: GlsShippingInformation
): GlsOrderStatus | null => {
    let shippingType = OrderService.getShippingType(order);
    if (shippingType !== ShippingType.GLS) {
        return null;
    }

    if (!glsShippingInfo) {
        return GlsOrderStatus.SHIPMENT_AWAITING;
    }
    return glsShippingInfo.status;
};

//todo createParcels
const createParcels = async (ecomId: number, orderIds: number[]) => {
    const apiTestMode = store.getState().settings.settings[SettingKey.use_test_api_gls];
    await checkApiKeysWithErrorToast(ecomId, apiTestMode);
    const senderDetailsSetting = store.getState().settings.settings[SettingKey.sender_details];
    await SettingService.checkSenderDetailsValidityWithErrorToast(senderDetailsSetting);

    let res = await httpApi.post<GlsCreateParcelsResponse>(`/api/ecom/${ecomId}/gls/create-parcels`, {
        shopify_order_ids: orderIds,
    });
    let data = res.getData();
    return data;
};

export default {
    injectStore,
    getShippingInfoForOrders,
    getShippingInfoForOrder,
    getStatus,
    createParcels,
    downloadLabelsPdfForOrderIds,
};
